import { render, staticRenderFns } from "./EditTaxonomyPhyllum.vue?vue&type=template&id=0c6b90bc&"
import script from "./EditTaxonomyPhyllum.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyPhyllum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports